var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container error-message"},[_c('h1',[_vm._v("\n    "+_vm._s(_vm.msg)+"\n  ")]),_vm._v(" "),_c('router-link',{attrs:{"to":{name:'Home'}}},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("\n      Back to Toolkit Home\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }